import { Users, UserCheck, Zap, TrendingUp } from "lucide-react";
import { useTranslation } from "react-i18next";
import { StatCard } from "../dashboard/StatCard";
import { SubscriptionStats as StatsType } from "@/hooks/useSubscriptionStats";

interface SubscriptionStatsProps {
  stats: StatsType | null;
  loading: boolean;
}

export function SubscriptionStats({ stats, loading }: SubscriptionStatsProps) {
  const { t } = useTranslation();
  
  return (
    <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
      <StatCard
        title={t('admin.sales.stats.totalUsers')}
        value={loading ? "-" : stats?.total || 0}
        icon={Users}
        color="yellow"
      />
      <StatCard
        title={t('admin.sales.stats.freeUsers')}
        value={loading ? "-" : stats?.free || 0}
        icon={UserCheck}
        color="cyan"
      />
      <StatCard
        title={t('admin.sales.stats.proUsers')}
        value={loading ? "-" : stats?.pro || 0}
        icon={Zap}
        color="pink"
      />
      <StatCard
        title={t('admin.sales.stats.standardUsers')}
        value={loading ? "-" : stats?.standard || 0}
        icon={TrendingUp}
        color="blue"
      />
    </div>
  );
}

import { StatCard as OriginalStatCard } from "../dashboard/StatCard";
// Re-exporting or using same component
